import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Home,
  CheckSquare,
  Target,
  CalendarDays,
  Clock,
  AlertTriangle,
  ShieldCheck,
  Inbox,
  Users,
  Plus,
  Settings,
  LogOut,
  ChevronDown,
} from "lucide-react";
import { LOGO_URL, avatarFor, initialsFor } from "@/lib/utils-tg";
import { useAuth } from "@/context/AuthContext";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from "@/components/ui/dropdown-menu";

const NAV = [
  { to: "/", label: "Home", icon: Home, end: true },
  { to: "/tasks", label: "Tasks", icon: CheckSquare },
  { to: "/goals", label: "Goals", icon: Target },
  { to: "/meetings", label: "Meetings", icon: CalendarDays },
  { to: "/timesheet", label: "Timesheet", icon: Clock },
  { to: "/issues", label: "Issues", icon: AlertTriangle },
  { to: "/approvals", label: "Approvals", icon: ShieldCheck },
  { to: "/inbox", label: "Inbox", icon: Inbox },
  { to: "/team", label: "Team", icon: Users },
];

export default function Sidebar({ onNew }) {
  const { user, logout, setRole } = useAuth();
  const nav = useNavigate();

  return (
    <aside
      className="hidden md:flex w-64 fixed left-0 top-0 bottom-0 bg-white border-r border-slate-200 z-40 flex-col"
      data-testid="sidebar"
    >
      <div className="flex items-center justify-center gap-1 px-4 pt-5 pb-4">
        <img src={LOGO_URL} alt="Talk & Go" className="h-18 w-auto object-contain" style={{height: '4.5rem'}} />
        <span className="text-[9px] font-semibold uppercase tracking-wider text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full px-1.5 py-0.5 -mt-6" data-testid="beta-badge">
          beta
        </span>
      </div>

      <div className="px-4 pb-3">
        <button
          type="button"
          onClick={onNew}
          className="tg-btn-primary w-full"
          data-testid="sidebar-new-button"
        >
          <Plus className="h-4 w-4" />
          New
        </button>
      </div>

      <nav className="px-3 flex-1 overflow-y-auto">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            data-testid={`nav-${item.label.toLowerCase()}`}
            className="block mb-1"
          >
            {({ isActive }) => (
              <div className="tg-nav-item" data-active={isActive}>
                <item.icon className="h-4 w-4" />
                <span>{item.label}</span>
              </div>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-slate-200 p-3 space-y-1">
        <button
          type="button"
          onClick={() => nav("/settings")}
          className="tg-nav-item w-full"
          data-testid="sidebar-settings"
        >
          <Settings className="h-4 w-4" /> Settings
        </button>
      </div>
    </aside>
  );
}

export { initialsFor };
